import { INGREDIENT_DETAILS_PATH } from '@/constants/paths';

export const getIngredientDetailsPageUrl = (id: number) => {
  return INGREDIENT_DETAILS_PATH.replace(':id', String(id));
};
